// @ts-nocheck
import _ from 'lodash';
import { createTheme, Divider, IconButton, withStyles, Card } from '@material-ui/core';
import CardMedia from '@material-ui/core/CardMedia';
import { MuiThemeProvider } from '@material-ui/core/styles';
import ArrowIcon from '@material-ui/icons/KeyboardArrowRight';
import CheckIcon from '@material-ui/icons/CheckCircle';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { BLUE, GREEN, ORANGE, RED, STORE_ITEMS_TYPES_MAP } from '../../_config/consts';
import MDButton from '../MDButton/MDButton.jsx';
import CreditsIconCustom from '../CustomIcons/CreditsIconCustom.jsx';
import { connect } from 'react-redux';
import ArrowRightIconCustom from '../CustomIcons/ArrowRightIconCustom.jsx';
import Warning from '@material-ui/icons/Warning';
import InfoSection from '../InfoSection/InfoSection.jsx';

const styles = theme => ({
  container: {
    borderRadius: 10,
    justifyContent: 'center',
    position: 'relative',
    marginBottom: 15,
  },
  title: {
    fontWeight: 'bold',
    color: '#3f3f3f',
    textAlign: 'center',
  },
  creditsInnerContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  creditsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  costText: {
    fontSize: 28,
    color: GREEN,
    margin: 0,
    fontWeight: 700,
  },
  costDescriptionText: {
    fontWeight: 600,
    color: '#5a6c7d',
    margin: 0,
    fontSize: 14,
    marginTop: 8,
  },
  recurrentText: {
    color: ORANGE,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 0,
    marginTop: 20,
    fontSize: 16,
    fontWeight: 600,
  },
  warningContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 30,
  },
  unifiedCard: {
    width: '100%',
    maxWidth: 800,
    margin: '30px auto',
    padding: 0,
    borderRadius: 20,
    backgroundColor: '#ffffff',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.12)',
    overflow: 'hidden',
    border: '1px solid #e9ecef',
  },
  itemDetailsSection: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '30px 40px',
    backgroundColor: '#f8f9fa',
    borderBottom: '1px solid #e9ecef',
  },
  mediaContainer: {
    position: 'relative',
    marginRight: 25,
    flexShrink: 0,
  },
  media: {
    width: 120,
    height: 120,
    objectFit: 'cover',
    borderRadius: 16,
    border: '3px solid #fff',
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
  },
  itemTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    flex: 1,
    minWidth: 0,
  },
  titleText: {
    fontSize: 28,
    fontWeight: 700,
    margin: 0,
    color: '#2c3e50',
    lineHeight: 1.3,
    wordBreak: 'break-word',
  },
  itemSubtitle: {
    fontSize: 14,
    color: '#7f8c8d',
    marginTop: 8,
    fontWeight: 500,
    textTransform: 'uppercase',
    letterSpacing: '0.5px',
  },
  pricingSection: {
    padding: '35px 40px',
    backgroundColor: '#ffffff',
  },
  pricingSectionTitle: {
    textAlign: 'center',
    marginTop: 0,
    marginBottom: 25,
    fontSize: 20,
    fontWeight: 700,
    color: '#2c3e50',
  },
});

const theme = createTheme({
  palette: {
    primary: { 500: BLUE },
  },
});

@connect(state => ({ wallet: state.cloudCredits.wallet }))
class StoreActivationView extends React.Component {
  render() {
    const { classes, item, wallet, onActivateSubscription, onRechargeWalletRequest } = this.props;
    const isItemFree = item.fixedPrice === 0 && item.burnRateDaily === 0 && item.burnRate === 0;
    const isCreditInsufficient = !isItemFree && wallet.availableCredits <= item.fixedPrice;
    const hasActivationFee = item.fixedPrice > 0;
    const hasRecurringCost = item.burnRate > 0;

    const isMultiResourceItem = item.hasMultipleResources;

    return (
      <MuiThemeProvider theme={theme}>
        <div style={{ padding: '40px 60px', minHeight: 500 }}>
          <div className={classes.container}>
            <h1 className={classes.title} style={{ 
              margin: 0, 
              fontSize: 34, 
              fontWeight: 700, 
              color: '#2c3e50',
              marginBottom: 10,
              letterSpacing: '-0.5px'
            }}>
              <Entity entity="activateSubscription" />
            </h1>
            {isItemFree && (
              <InfoSection
                gravity="success"
                title="freeSubscription"
                subtitle="freeSubscriptionDescription"
                containerStyle={{ marginTop: 20, marginBottom: 10 }}
              />
            )}
            
            <Card className={classes.unifiedCard}>
              {/* Item Details Section */}
              <div className={classes.itemDetailsSection}>
                <div className={classes.mediaContainer}>
                  <CardMedia
                    className={classes.media}
                    image={item && item.previewImage ? item.previewImage : item.coverImage}
                  />
                </div>
                <div className={classes.itemTextContainer}>
                  <h2 className={classes.titleText}>
                  {isMultiResourceItem ? (
                    <Entity entity={item.resource} />
                  ) : (
                    <>
                    {item.renderedTitle ? item.renderedTitle : <Entity entity={item.title} />}
                    </>
                  )}
                  </h2>
                  <p className={classes.itemSubtitle}>
                    <Entity entity={STORE_ITEMS_TYPES_MAP[item.type].nameSingle} />
                  </p>
                </div>
              </div>
              
              {/* Pricing Section */}
              {!isItemFree && (
                <div className={classes.pricingSection}>
                  <h2 className={classes.pricingSectionTitle}>
                    <Entity entity="howYourWalletChange" />
                  </h2>
                  
                  {hasRecurringCost && (
                    <>
                      <div className={classes.creditsContainer}>
                        <div className={classes.creditsInnerContainer} style={{ marginRight: 30 }}>
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <h4 className={classes.costText}>
                              <Entity entity="walletCreditsConsumptionText" data={{ credits: wallet.burnRate }} />
                            </h4>
                          </div>
                          <h4 className={classes.costDescriptionText}><Entity entity="currentBurnRate" /></h4>
                        </div>
                        <ArrowRightIconCustom style={{ width: 50, color: '#4DB6AC', margin: '0 10px' }} />
                        <div className={classes.creditsInnerContainer} style={{ marginLeft: 30 }}>
                          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                            <h4 className={classes.costText}>
                              <Entity entity="walletCreditsConsumptionText" data={{ credits: wallet.burnRate + item.burnRate }} />
                            </h4>
                          </div>
                          <h4 className={classes.costDescriptionText}><Entity entity="updatedBurnRate" /></h4>
                        </div>
                      </div>
                      {hasActivationFee && <Divider style={{ marginTop: 25, marginBottom: 20 }} />}
                    </>
                  )}
                  
                  {hasActivationFee && (
                    <h4 className={classes.recurrentText}>
                      <Entity entity="extensionCost" data={{ credits: item.fixedPrice }} />
                      <CreditsIconCustom style={{ color: ORANGE, width: 20, marginLeft: 2 }} />
                    </h4>
                  )}
                </div>
              )}
            </Card>
            
            {!isItemFree && hasRecurringCost && !isCreditInsufficient && (
              <InfoSection
                gravity="info"
                title="recurringCostInfo"
                subtitle="recurringCostInfoDescription"
                containerStyle={{ marginTop: 15, marginBottom: 10 }}
              />
            )}
            
            {isCreditInsufficient && (
              <InfoSection
                gravity="error"
                title="unsufficientCredit"
                subtitle="unsufficientCreditDescription"
                containerStyle={{ marginTop: 15, marginBottom: 15 }}
                body={
                  <MDButton
                    backgroundColor={GREEN}
                    onClick={() => onRechargeWalletRequest()}
                    style={{ width: '100%', marginTop: 10 }}
                    title={<Entity entity="rechargeWallet" />}
                  />
                }
              />
            )}
            
            <div className={classes.requestDemoContainer}>
              <MDButton
                title={<Entity entity="activateNow" />}
                containerStyle={{ marginTop: isCreditInsufficient ? 10 : 30, marginBottom: 0 }}
                titleStyle={{ fontSize: 17, fontWeight: 'bold' }}
                backgroundColor={GREEN}
                disabled={isCreditInsufficient}
                style={{ marginTop: 0, height: 50 }}
                onClick={() => onActivateSubscription()}
              />
            </div>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}
export default withStyles(styles)(StoreActivationView);
